<style>
  .secretKey-box .line-height20{
    line-height: 19px;
  }
  .secretKey-box .color{
    color: #003b80;
  }
</style>
<template>
  <div class="secretKey-box">
    <div class="shade-box ">
      <div class="shade-content position-top">
        <p class="dialog-title-bg line-height20">获取秘钥
        <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="cancelGetKey('getKeyForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="keyForm" ref="getKeyForm" label-width="100px" class="demo-ruleForm" :rules="$rules">
            <el-form-item label-width="30px">
              <p class="color">为了您的账号安全，进行敏感操作前须先验证身份</p>
            </el-form-item>
            <el-form-item label="绑定手机">
              <p>{{keyForm.userPhone}}</p>
            </el-form-item>
            <el-form-item label="验证码" prop="codeImg">
              <el-input class="code" v-model="keyForm.codeImg" auto-complete="off" placeholder="请输入验证码" maxlength="6"></el-input>
              <img :src="'data:image/gif;base64,' + imgCode" class="img-code" @click="getImgCode" v-if="imgCode">
            </el-form-item>
            <!-- <el-form-item label="短信验证码" prop="msgCode" v-if="show">
              <el-input class="code" v-model="keyForm.msgCode" placeholder="请输入短信验证码" maxlength="6" auto-complete="off" @keyup.enter.native="submitForm('revisePhoneForm')"></el-input>
              <span @click="getMsgCode" class="img-code get-code">获取短信验证码</span>
            </el-form-item> -->
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('getKeyForm')" :disabled="disabled">确认</el-button>
              <el-button @click="cancelGetKey('getKeyForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  name: "secretKey",
  data(){
    return{
      disabled: false,
      imgCode: '',
      keyForm: {
        userPhone: '',
        imagetoken: '',
        codeImg: ''
      }
    };
  },
  created(){
    this.$nextTick(function(){
      this.$refs.userPhoneInput.focus();
    });
    this.getImgCode();
    this.keyForm.userPhone = JSON.parse(localStorage.getItem("USER")).userPhone;
  },
  methods: {
    getImgCode(){//获取图片验证码
      this.keyForm.codeImg = '';
      api.getMsgCode({parms: {}}).then(res => {
        if(res.status == 'success'){
          this.imgCode = res.data.img;
          this.keyForm.imagetoken = res.data.imagetoken;
        }
      })
    },
    submitForm(formName){//修改
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          let data = {
            "verifyCode": this.keyForm.codeImg,
            "imagetoken": this.keyForm.imagetoken,
          }
          api.getApiSecrect({params:data}).then(res => {
            this.disabled = false;
            if(res.status == 'success'){
              this.$message.success(res.msg);
              this.cancelGetKey('getKeyForm');
            }
          })
        } else {
          return false;
        }
      });
    },
    cancelGetKey(formName){//取消修改
      this.$refs[formName].resetFields();
      this.$emit('colseKey')
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/layout/secretkey.vue